import React, { useState } from "react";
import { generateKey, getTrue } from "../../../shared/utils";
import { price } from "../../static-data/productStatic";
import { SUPPORTED_REGIONS, CURRENCY_SIGN } from "../../../shared/enums";

const OrderCard = ({ localization, type }) => {
  const { region } = localization;
  console.log('Localization Order card', localization);
  const regional = SUPPORTED_REGIONS[region] || SUPPORTED_REGIONS.US;

  const { unit, filter } = price[type][regional];

  // const isDiscountEnabled = getTrue(ENABLE_DISCOUNT);
  const isDiscountEnabled = false;
  const discountFactor = getTrue(regional == "US") ? 0.2 : 0.15;
  const discountPrice = isDiscountEnabled
    ? Math.round(Number(unit) - Number(unit) * discountFactor)
    : Number(unit);

  const radioIdOne = generateKey("free");
  const radioIdTwo = generateKey("price");
  const inputName = generateKey("name");

  const [currentPrice, setCurrentPrice] = useState(discountPrice);
  const [isFilled, setIsFilled] = useState(true);
  const [option, setOption] = useState("auto-fill");

  const changeHandler = (e, optionVal) => {
    setCurrentPrice(e.target.value);
    setOption(optionVal);
  };

  // Australia,Singapore,UK,EU - air 20th series else air 30th series
  const preferredAir = [
    SUPPORTED_REGIONS.AU,
    SUPPORTED_REGIONS.SG,
    SUPPORTED_REGIONS.GB,
    SUPPORTED_REGIONS.EU
  ].includes(regional) ? 'air' : 'air3';

  const autoFill = `https://shop.milacares.com?product=${preferredAir}&filter=cc&ar=true`;
  const noFill = `https://shop.milacares.com?product=${preferredAir}&filter=cc&ar=false`;

  const shoupUrl = isFilled ? autoFill : noFill;

  return (
    <div className="order-card__holder">
      <div className="order-card">
        <div className="order-card__header">
          <p className="order-card__price-info">
            <span>Purchase Mila</span>
            <br /> starting at just
            <strong>
              {getTrue(ENABLE_DISCOUNT) && (
                <span className="order-card__old-price">
                  <sub>{CURRENCY_SIGN[region]}</sub>
                  {`${unit}`}
                </span>
              )}
              <span className="order-card__offer-price">
                <sub>{CURRENCY_SIGN[region]}</sub>
                {`${discountPrice}`}
              </span>
            </strong>
            Per unit
          </p>
        </div>
        <div className="order-card__devider">
          <svg viewBox="0 0 380 20" fill="none">
            <path
              d="M0 0H380C368.258 1.08421 368.258 18.2301 380 19.3143H0C11.6079 18.1085 11.6079 1.20581 0 0Z"
              fill="white"
            />
            <path
              opacity="0.1"
              d="M7.55469 10.4L372.448 10.4001"
              stroke="black"
              strokeWidth="2"
              strokeLinecap="round"
              strokeLinejoin="round"
              strokeDasharray="8 8"
            />
          </svg>
        </div>
        <div className="order-card__body">
          <h3 className="order-card__title">Add The Critter Cuddler filter</h3>
          <label htmlFor={radioIdOne} className="custom-radio">
            <input
              id={radioIdOne}
              type="radio"
              name={inputName}
              className="custom-radio__input"
              readOnly
              value={discountPrice || unit}
              checked={option === "auto-fill"}
              onChange={(e) => {
                changeHandler(e, "auto-fill");
                setIsFilled(true);
              }}
            />
            <div className="custom-radio__content">
              <h3 className="custom-radio__price">Free</h3>
              <p>
                With Auto-Refill. Get fresh filters delivered every six months.
                Cancel anytime.
              </p>
            </div>
          </label>
          <label htmlFor={radioIdTwo} className="custom-radio">
            <input
              id={radioIdTwo}
              type="radio"
              name={inputName}
              className="custom-radio__input"
              readOnly
              value={Number(discountPrice || unit) + Number(filter)}
              checked={option === "no-fill"}
              onChange={(e) => {
                changeHandler(e, "no-fill");
                setIsFilled(false);
              }}
            />
            <div className="custom-radio__content">
              <h3 className="custom-radio__price">{`+${CURRENCY_SIGN[region]}${filter}`}</h3>
              <p>Without Auto-Refill</p>
            </div>
          </label>
        </div>
      </div>
      <a
        href={shoupUrl}
        className="shop-button"
        rel="noreferrer noopener"
        target="_blank"
      >
        Shop now - {CURRENCY_SIGN[region]}
        {currentPrice}
      </a>
      <p className="order-wrapper__addition-text">
        Looking to buy multiple units?{" "}
        <a
          href="https://milacares.com/buy"
          rel="noreferrer noopener"
          target="_blank"
        >
          Order here
        </a>
      </p>
    </div>
  );
};

export default OrderCard;
